
<!--
 * @Description:布置作业
 * @Author: 王丽欣
 * @Date: 2023-03-01 17:32:04
 * @LastEditors: PF
 * @LastEditTime: 2024-01-31 13:30:52
-->
<template>
  <div class="list-page pl0 pt0 pr0 pb0">
    <el-container>
      <el-main>
        <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px" status-icon>
          <el-row>
            <el-col :span="12">
              <el-form-item label="学期:">
                <span>{{xqmc}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="课程:">
                {{bjlist[0].kcmc}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="周次:">
                <span>第{{zc}}周</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="班级/节次:" class="bjjc">
                <el-row>
                  <el-col :span="12" v-for="item in chechboxtrue" :key="item.id">
                    <div style="width:300px">
                      <span>{{item.bjmc}}/星期{{item.xq}}第{{item.jc}}节</span>
                    </div>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="教学单元" prop="jxdyid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-select class="mr10" v-model="ruleForm.jxdyid" filterable clearable :teleported="false" style="width: calc(100% - 70px);" @change="initJiaoXueNeiRong">
                  <el-option v-for="item in jxdyData" :key="item.id" :label="item.jxdybt" :value="item.id" />
                </el-select>
                <el-button type="primary" @click="openAddJiaoXueDanYuan=true;row={kcid:kcid,kcmc:bjlist[0].kcmc}">添加</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="教学内容" prop="jxnrid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-select class="mr10" v-model="ruleForm.jxnrid" filterable clearable :teleported="false" style="width: calc(100% - 70px);" @change="initZuoYe()">
                  <el-option v-for="item in jxnrData" :key="item.id" :label="item.jxnrbt" :value="item.id"/>
                </el-select>
                <el-button type="primary" @click="openAddJiaoXueNeiRong=true;row={kcid:kcid,kcmc:bjlist[0].kcmc,jxdyid:ruleForm.jxdyid}">添加</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="作业" prop="zyid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-select class="mr10" v-model="ruleForm.zyid" filterable clearable :teleported="false">
                  <el-option v-for="item in zyData" :key="item.id" :label="item.zymc" :value="item.id" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="截止时间" prop="jzsj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-date-picker v-model="ruleForm.jzsj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm"/>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="计入平时成绩" prop="sfjrpscj" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
                <el-radio-group v-model="ruleForm.sfjrpscj">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-main>
      <el-footer class="el-dialog__footer">
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" v-if="sfwc" @click="submit()">保存</el-button>
            <el-button @click="handleClose">关闭</el-button>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
  <jiaoxuedanyuan v-if="openAddJiaoXueDanYuan" v-model:openAdd="openAddJiaoXueDanYuan" :row="row" @ReturnData="initJiaoXueDanYuan"/>
  <jiaoxueneirong v-if="openAddJiaoXueNeiRong" v-model:openAdd="openAddJiaoXueNeiRong" :row="row" @ReturnData="initJiaoXueNeiRong"/>
</template>
<script setup>
import { ref, watch, defineProps, defineEmits, unref } from 'vue'
import { closeWindow, loadSelect, submitForm, actionPost } from '@/api/common.js'
import jiaoxuedanyuan from './jiaoxuedanyuan.vue'
import jiaoxueneirong from './jiaoxueneirong.vue'
const props = defineProps({ openAdd: { type: Boolean, required: true }, row: { type: Object, required: false }, chechboxtrue: { type: Array, required: false } })
const ruleFormRef = ref(null)
const ruleForm = ref({})
const bjlist = ref()
const xqid = ref()
const xqmc = ref()
const zc = ref()
const jxnrData = ref([])
const jxdyData = ref([])
const kcid = ref() // 课程ID
const openAddJiaoXueDanYuan = ref()// 添加教学单元
const openAddJiaoXueNeiRong = ref()// 添加教学内容
const row = ref()
const emits = defineEmits(['update:openAdd', 'ReturnData', 'guanBi'])
// 查询教学单元
const initJiaoXueDanYuan = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/kechengjiaoxuedanyuan/list',
    data: jxdyData,
    parms: { kcid: kcid.value, order: 'sx', sort: 'asc' }
  })
  ruleForm.value.zyid = null
  ruleForm.value.zymc = null
  ruleForm.value.jxnrid = null
}

// 查询教学内容
const initJiaoXueNeiRong = () => {
  ruleForm.value.zyid = null
  ruleForm.value.zymc = null
  const o = { url: '/api/v2/ziyuanku/kechengjiaoxueneirong/list', data: { jxdyid: ruleForm.value.jxdyid, order: 'sx', sort: 'asc' } }
  actionPost(o).then((res) => {
    jxnrData.value = res.data
  })
}
const zyData = ref()
const initZuoYe = () => {
  loadSelect({
    url: '/api/v2/ziyuanku/zuoye/jiaoshilist',
    data: zyData,
    parms: { zylx: ruleForm.value.zylx, kcid: kcid.value, jxdyid: ruleForm.value.jxdyid, jxnrid: ruleForm.value.jxnrid, order: 'kcmc', sort: 'asc' }
  })
}
// 关闭
const handleClose = () => {
  closeWindow('openAdd', emits, true)
  emits('update:openAdd', false)
  emits('guanBi', true)
}
watch(
  () => props.chechboxtrue,
  () => {
    if (props.chechboxtrue) {
      bjlist.value = props.chechboxtrue
    }
  },
  { deep: true, immediate: true }
)

const zylxData = ref({ list: [] })
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      loadSelect({ url: '/api/v2/ziyuanku/zuoye/zuoyeleixing', data: zylxData, loadSuccess: function (res) { ruleForm.value.zylx = res.data.xianShangZuoYe } })
      row.value = props.row
      kcid.value = row.value.chechboxtrue[0].kcid
      xqmc.value = row.value.xqmc
      xqid.value = row.value.xqid
      zc.value = row.value.zc
      initJiaoXueDanYuan()
    }
  },
  { deep: true, immediate: true }
)

// 保存
const sfwc = ref(true)
const submit = async () => {
  const form = unref(ruleFormRef)
  if (!form) return
  await form.validate()
  ruleForm.value.jc = bjlist.value[0].jc
  ruleForm.value.xq = bjlist.value[0].xq
  ruleForm.value.jskbid = bjlist.value[0].id
  ruleForm.value.zc = row.value.zc
  ruleForm.value.xqid = row.value.xqid
  ruleForm.value.menuId = sessionStorage.getItem('menuId')
  submitForm({
    url: '/api/v2/ziyuanku/xueshengzuoye/buzhi',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function () {
      sfwc.value = false
    }
  })
}
</script>
